import { StyleSheet } from 'react-native';
import { brand, neutrals } from 'src/theme/colors';

export const style = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 16,
    gap: 30,
    paddingHorizontal: 4,
  },
  leftElement: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  leftTextContainer: {
    gap: 8,
    flex: 1,
  },
  leftTextTitle: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 20,
    color: neutrals.neutralGrays.graphite,
  },
  leftTextDescription: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 24,
    color: neutrals.neutralGrays.graphite,
  },
  rightElement: {
    width: '100%',
  },
  tableRow: {
    paddingVertical: 8,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  border: {
    borderBottomWidth: 1,
    borderColor: brand.main.variations['lighterWater-2'],
  },
  rowRightElement: {
    gap: 8,
  },
  rowRightElementInColumn: {
    flexDirection: 'column',
  },
  rowRightElementInRow: {
    flexDirection: 'row-reverse',
  },
  rowElementText: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 18,
    color: neutrals.neutralGrays.graphite,
  },
  rowElementTextBold: {
    fontWeight: 700,
  },
  discountText: {
    flexDirection: 'row',
    gap: 4,
  },
  discount: {
    width: 'fit-content',
    paddingHorizontal: 6,
    paddingVertical: 4,
    backgroundColor: brand.main.orange,
    borderRadius: 50,
    color: neutrals.white,
    fontWeight: 700,
    fontSize: 12,
    lineHeight: 12,
  },
});
